export default {
    mailTemplateBaseData: 'Daten',
    mailTemplateActivities: 'Historie'
}